module.exports = __webpack_public_path__ + "media/images/talent/intro-bg-b33e78b650945ca5644134bc54a8aa4a.png";